module.exports = __webpack_public_path__ + "img/organge_cash.1c4e9ee6.png";